import React from 'react';
import { useSelector } from 'react-redux';
import _, { map } from 'lodash';
import {
  type TReservationSetting,
  reservationMappingSelector,
} from 'slices/reservationSettings.slice';
import { Form, Select, Typography } from '@timeedit/ui-components/antd';

const { Title } = Typography;
type Object = { [key: string]: any };

type Props = {
  fields: Object;
  label: string;
  onChange: (data: TReservationSetting) => void;
};

const GeneralTemplate = ({ fields, label, onChange }: Props) => {
  const reservationMapping = useSelector(reservationMappingSelector);

  return (
    <div>
      {label && <Title level={3}>{label}</Title>}
      {map(fields, (field, appFieldId) => {
        const { optionsSource, required, label } = field || {};
        const options = _.get(reservationMapping, optionsSource, []);
        return (
          <Form.Item
            label={label}
            key={appFieldId}
            rules={[{ required, message: '' }]}
            name={appFieldId}
          >
            <Select
              onChange={(value) => {
                onChange({ appFieldId, fieldExt: value });
              }}
              allowClear
              showSearch
            >
              {options.map(
                (
                  { label, value }: { label: string; value: string },
                  index: number
                ) => (
                  <Select.Option key={index} value={value}>
                    {label}
                  </Select.Option>
                )
              )}
            </Select>
          </Form.Item>
        );
      })}
    </div>
  );
};

export default GeneralTemplate;
